function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.316 12.183A9.965 9.965 0 0123 19c0 5.523-4.477 10-10 10S3 24.523 3 19 7.477 9 13 9c2.167 0 4.173.69 5.81 1.86L23.658 6H19.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h6.571a1 1 0 011 1v6.571a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V7.414l-4.755 4.769zM5 19a8 8 0 1116 0 8 8 0 01-16 0z",
  fill: "currentColor"
})));